import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgSupportCenterGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M37.816 10.35c-.59-.65-1.52-1.53-2.61-2.01-1.36-.59-2.61-.42-3.63.5-1.22 1.1-3.48 3.5-4.75 4.96-.71.82-.94 1.82-.67 2.9.56 2.2 3.11 4.22 4.74 4.82.39.14.82-.05.97-.44a.736.736 0 0 0-.44-.96c-1.31-.49-3.4-2.17-3.81-3.79-.15-.6-.04-1.11.35-1.55 1.38-1.58 3.58-3.89 4.62-4.84.57-.52 1.21-.6 2.02-.24.66.29 1.4.87 2.1 1.64 1.68 1.85 2.17 3.98 1.51 6.51-1 3.84-2.6 8.07-7.45 13.03-3.74 3.83-6.8 5.72-11.67 7.23-3.78 1.16-6.43-.51-8.73-2.5-.52-.45-.83-1-.87-1.56-.03-.44.11-.84.41-1.18.35-.39 1.39-1.36 2.4-2.29.86-.8 1.76-1.63 2.25-2.13.31-.31.81-.67 1.43-.56.79.13 1.59.95 2.19 2.23.37.8.92 1.28 1.62 1.42 1.6.32 3.59-1.18 7.2-4.46 2.26-2.06 3.26-3.48 3.3-3.54a.75.75 0 0 0-.19-1.04.75.75 0 0 0-1.04.19c-.01.01-.95 1.36-3.07 3.28-1.78 1.62-4.77 4.33-5.89 4.1-.08-.02-.31-.06-.55-.58-.82-1.76-2-2.85-3.3-3.08-.99-.17-1.97.18-2.76.99-.46.47-1.34 1.29-2.2 2.08-1.08 1.01-2.11 1.96-2.5 2.4a3.13 3.13 0 0 0-.79 2.28c.06.96.56 1.88 1.38 2.6 1.93 1.67 4.26 3.25 7.28 3.25.89 0 1.85-.14 2.87-.45 5.08-1.57 8.41-3.63 12.3-7.61 5.09-5.21 6.77-9.66 7.82-13.7.8-3.01.18-5.67-1.84-7.9Z",
    fill: "currentColor"
  }));
}

export { SvgSupportCenterGlyphSecondary as default };
